import useIsMobile from 'utils/hooks/useIsMobile'
import {
  Build as BuildIcon,
  Cancel as CancelIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
  Help as HelpIcon,
  HighlightOff as HighlightOffIcon,
  OfflinePin as OfflinePinIcon,
  Refresh as RefreshIcon,
  Search as SearchIcon,
  TaskAlt as TaskAltIcon,
  Unpublished as UnpublishedIcon,
} from '@mui/icons-material'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore' // MUI 아이콘 추가
import ListAltIcon from '@mui/icons-material/ListAlt'
import MenuIcon from '@mui/icons-material/Menu'
import ReplayIcon from '@mui/icons-material/Replay'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import {
  Button,
  Checkbox,
  Fade,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import Box from '@mui/material/Box'
import {DatePicker, DateRangePicker, LocalizationProvider} from '@mui/x-date-pickers-pro'
import {AdapterDayjs} from '@mui/x-date-pickers-pro/AdapterDayjs'
import * as bootstrap from 'bootstrap'
import dayjs from 'dayjs'
import _ from 'lodash'
import React, {Fragment, useState} from 'react'
import {useSelector} from 'react-redux'
import {cancelAs, registerAs} from 'utils/apiCalling/api'
import {dividedDistrictUiseongEnum} from 'utils/const/globalConst'
import {useServerCycleSetting} from 'utils/config/serverCycleConfig'
import {noDataAlert, normalAlert, validationAlert} from 'utils/CustomAlert/Alert'
import {CustomSwitch} from 'utils/designSytem/CustomSwitch'
import {CustomWidthTooltip} from 'utils/designSytem/CustomTooltip'
import {CustomDateBox} from './customerDateBox'
import {CustomSelectBox} from './customSelectBox'
import {CustomTextField} from './customTextField'

const MeterariumPageLayout = (props: any) => {
  const isMobile = useIsMobile()
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  /* 통신주기 선택지는 사업소마다 다르다 (/dev/server-cycle-config 에서 관리) */
  const serverCycleOptions = useServerCycleSetting(officeInfo?.value).options
  const [expanded, setExpanded] = useState(false)

  //filter 분리

  const {
    errorCount,
    headerDescription,
    children,
    filter,
    id,
    total,
    checkData,
    setFilter,
    tooltipText,
    control,
    hideSearchOptions,
    setHideSearchOptions,
    disableSearchOptions, // 누수의심
    actions,
    searchCallback,
    resetCallbalck,
    date,
    setDate,
    pannel,
    searchOptions,
    onDelete,
    accountTypeList,
    setTypeName,
    onCancel,
    onAssignCancel,
    onCreateUserModalOpen,
    buttonHandler,
    asValue = {},
    newSearchOptions,
    newSearchField,
    newSearchFieldFilter,
    selectedCount,
    downloadApi,
    loading,
    onDownloadOpen,
    onFotaOpen,
    hideTotalCount,
    compactSearch,
    dateFieldsInDefaultSearch,
    issueDateError,
    // 이슈 조회 날짜 옆 빠른 기간 버튼(예: 1주일/1개월). [{label, onClick, tooltip}] 형태로 넘기면 렌더.
    // 실제 날짜 계산은 호출 페이지가 담당(공용 레이아웃은 버튼만 표시).
    issueDateQuickButtons,
    // 값이 증가하면 시작일 입력창에 파란 테두리 플래시 애니메이션을 실행(피드백용)
    issueStartDateFlashKey,
  } = props

  const {
    asReasonData,
    setAsReasonData,
    setCheckData,
    setSelectionModel,
    causeList,
    solutionList,
    setHiddenClick,
    hiddenClick,
    setOpenCorrectModal,
    // 페이지가 따로 넘기지 않으면 기존처럼 searchCallback으로 갱신
    refreshCallback,
  } = asValue
  const asRefreshCallback = refreshCallback ?? searchCallback

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  /* A/S 일괄 등록·취소 요청 중 재클릭으로 중복 등록되는 것을 막는다 */
  const [asPending, setAsPending] = useState(false)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const formControls: any = {
    asStatus: (
      <FormControl className={id === 'customer-info' ? 'col-lg-1' : 'col-lg-2'} key={'fC-device'}>
        <InputLabel id='demo-simple-select-label'>A/S 상태</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='asStatus'
          label='A/S 상태'
          onChange={(e) => {
            setFilter({...filter, customerStatus: e.target.value, page: 1})
          }}
          defaultValue={filter?.customerStatus ?? 'all'}
        >
          <MenuItem value='all'>전체</MenuItem>
          <MenuItem value='as'>A/S</MenuItem>
        </Select>
      </FormControl>
    ),
    assign: (
      <FormControl className={'col-lg-1'} key={'fC-assign'}>
        <InputLabel id='demo-simple-select-label'>할당상태</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='assignStatus'
          label='할당상태'
          defaultValue={filter?.assignStatus}
          onChange={(e) => setFilter({...filter, assignStatus: e.target.value})}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'assigned'}>할당</MenuItem>
          <MenuItem value={'unassigned'}>미할당</MenuItem>
        </Select>
      </FormControl>
    ),
    installable: (
      <FormControl className={'col-lg-1'} key={'fC-installable'}>
        <InputLabel id='demo-simple-select-label'>설치가능 여부</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='install-available'
          label='설치가능 여부'
          defaultValue={filter?.assignStatus}
          onChange={(e) => setFilter({...filter, customerStatus: e.target.value})}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'true'}>가능</MenuItem>
          <MenuItem value={'false'}>불가능</MenuItem>
        </Select>
      </FormControl>
    ),
    device: (
      <FormControl className={id === 'customer-info' ? 'col-lg-1' : 'col-lg-2'} key={'fC-device'}>
        <InputLabel id='demo-simple-select-label'>단말기 통신상태</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          label='단말기 통신상태'
          onChange={(e) => {
            setFilter({...filter, deviceStatus: e.target.value})
          }}
          defaultValue={filter?.deviceStatus}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'true'}>정상</MenuItem>
          <MenuItem value={'false'}>점검</MenuItem>
        </Select>
      </FormControl>
    ),
    battery: (
      <FormControl className={id === 'customer-info' ? 'col-lg-1' : 'col-lg-2'} key={'fC-battery'}>
        <InputLabel id='demo-simple-select-label'>배터리 상태</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          label='배터리 상태'
          defaultValue={filter?.batteryStatus}
          onChange={(e) => {
            setFilter({...filter, batteryStatus: e.target.value})
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'true'}>정상</MenuItem>
          <MenuItem value={'false'}>점검</MenuItem>
        </Select>
      </FormControl>
    ),
    deviceType: (
      <FormControl
        className={id === 'customer-info' ? 'col-lg-1' : 'col-lg-2'}
        key={'fC-deviceType'}
      >
        <InputLabel id='demo-simple-select-label'>단말기 타입</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          defaultValue={filter?.deviceType}
          label='단말기 타입'
          onChange={(e) => {
            setFilter({...filter, deviceType: e.target.value})
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'analog'}>디지털 이미지</MenuItem>
          <MenuItem value={'digital'}>디지털 계량기</MenuItem>
        </Select>
      </FormControl>
    ),
    recognizedType: (
      <FormControl
        className={id === 'customer-info' ? 'col-lg-1' : 'col-lg-2'}
        key={'fC-recognizedType'}
      >
        <InputLabel id='demo-simple-select-label'>계량기 타입</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          defaultValue={filter?.recognizedType}
          label='계량기 타입'
          onChange={(e) => {
            setFilter({...filter, recognizedType: e.target.value})
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'analog'}>기계식 계량기</MenuItem>
          <MenuItem value={'digital'}>디지털 계량기</MenuItem>
        </Select>
      </FormControl>
    ),
    freezeWarning: (
      <FormControl className={'col-lg-2'} key={'fC-freezeWarning'}>
        <InputLabel id='demo-simple-select-label'>구분</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          defaultValue={filter?.freezeWarningType}
          label='구분'
          onChange={(e) => {
            setFilter({...filter, freezeWarningType: e.target.value})
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'normal'}>양호</MenuItem>
          <MenuItem value={'warning'}>주의</MenuItem>
          <MenuItem value={'dangerous'}>위험</MenuItem>
          <MenuItem value={'very-dangerous'}>매우 위험</MenuItem>
        </Select>
      </FormControl>
    ),

    efos: (
      <FormControl className={id === 'customer-info' ? 'col-lg-1' : 'col-lg-2'} key={'fC-efos'}>
        <InputLabel id='demo-simple-select-label'>계량기 통신상태</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          defaultValue={filter?.efosStatus}
          label='계량기 통신상태'
          onChange={(e) => {
            setFilter({...filter, efosStatus: e.target.value})
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'true'}>정상</MenuItem>
          <MenuItem value={'false'}>점검</MenuItem>
        </Select>
      </FormControl>
    ),
    selectDate: (
      <div id={'date-range'} className={'col-lg-2'} key={'fC-selectDate'}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label='날짜 선택'
            onChange={(newValue) =>
              setFilter({...filter, date: dayjs(newValue).format('YYYYMMDD')})
            }
            value={filter?.date}
            disableFuture={true}
            inputFormat={'YYYY년 MM월 DD일'}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </div>
    ),
    period: (
      <FormControl className={'col-lg-1'} key={'fC-period'}>
        <InputLabel id='demo-simple-select-label'>검색 기간 구분</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          label='검색 기간 구분'
          defaultValue={filter?.flag}
          onChange={(e) => {
            if (e.target.value === 'day') {
              setFilter({
                ...filter,
                flag: e.target.value,
                start: dayjs(filter?.end).subtract(14, 'd').format('YYYYMMDD'),
                end: dayjs().format('YYYYMMDD'),
              })
            } else if (e.target.value === 'week') {
              setFilter({
                ...filter,
                flag: e.target.value,
                start: 4,
                end: dayjs().format('YYYYMMDD'),
              })
            } else if (e.target.value === 'month') {
              setFilter({
                ...filter,
                flag: e.target.value,
                start: 3,
                end: dayjs().format('YYYYMM'),
              })
            }
          }}
        >
          <MenuItem value={'day'}>일</MenuItem>
          <MenuItem value={'week'}>주</MenuItem>
          <MenuItem value={'month'}>월</MenuItem>
          {/*<MenuItem value={'year'}>년</MenuItem>*/}
        </Select>
      </FormControl>
    ),
    selectMonth: (
      <div id={'date-range'} className={'col-lg-2'} key={'fC-selectMonth'}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label='날짜 선택'
            onChange={(newValue) => setFilter({...filter, date: dayjs(newValue).format('YYYYMM')})}
            views={['year', 'month']}
            openTo={'month'}
            value={filter?.date}
            disableFuture={true}
            inputFormat={'YYYY년 MM월'}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </div>
    ),
    rangeDate: (
      <Fragment key={'fC-rangeDate'}>
        <FormControl className={'col-lg-1'}>
          <InputLabel id='demo-simple-select-label'>검색 기간 구분</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='range-date'
            label='검색 기간 구분'
            defaultValue={filter?.flag}
            onChange={(e) => {
              if (e?.target?.value === 'day') {
                setFilter({
                  ...filter,
                  flag: 'day',
                  start: 1,
                  end: dayjs().format('YYYYMMDD'),
                })
              } else if (e.target.value === 'week') {
                setFilter({
                  ...filter,
                  flag: e.target.value,
                  start: 4,
                  end: dayjs().format('YYYYMMDD'),
                })
              } else if (e.target.value === 'month') {
                setFilter({
                  ...filter,
                  flag: e.target.value,
                  start: 3,
                  end: dayjs().format('YYYYMM'),
                })
              }
            }}
          >
            <MenuItem value={'day'}>일</MenuItem>
            <MenuItem value={'week'}>주</MenuItem>
            <MenuItem value={'month'}>월</MenuItem>
            {/*<MenuItem value={'year'}>년</MenuItem>*/}
          </Select>
        </FormControl>
        <div id={'date-range'} className={'col-lg-3'}>
          {filter?.flag === 'day' && (
            <div className={'d-flex gap-4'}>
              {/*<TextField*/}
              {/*  variant={'outlined'}*/}
              {/*  className={'col'}*/}
              {/*  disabled*/}
              {/*  label={`검색 시작날짜`}*/}
              {/*  defaultValue={dayjs(filter?.start).format('YYYYMMDD')}*/}
              {/*/>*/}
              <span className={'w-200px fs-6 align-self-center text-end'}>
                기준 날짜로부터 일자별로 모든 데이터를 불러옵니다.
              </span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label='기준 날짜 선택'
                  value={date}
                  disableFuture={true}
                  onChange={(newValue: any) => {
                    setDate(newValue)
                    setFilter({
                      ...filter,

                      end: dayjs(newValue).format('YYYYMMDD'),
                    })
                  }}
                  className={'col'}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
          )}
          {filter?.flag === 'week' && (
            <div className={'d-flex gap-3'}>
              <FormControl fullWidth>
                <InputLabel id='demo-simple-select-label'>기간 선택</InputLabel>
                <Select
                  labelId='demo-simple-select-label'
                  id='select-week'
                  defaultValue={4}
                  label='기간 선택 '
                  onChange={(e) => {
                    setFilter({...filter, start: e.target.value})
                  }}
                >
                  {_.map(_.range(1, 8), (el, i) => (
                    <MenuItem value={i + 1} key={i}>
                      {el}주차 전
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={['year', 'month', 'day']}
                  openTo='day'
                  mask={'____.__.__'}
                  inputFormat={'YYYY년 MM월 DD일'}
                  value={date}
                  disableFuture={true}
                  onChange={(newValue: any) => {
                    setDate(newValue)
                    setFilter({
                      ...filter,
                      end: dayjs(newValue).format('YYYYMMDD'),
                    })
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  minDate={new Date('2023-01-01')}
                  maxDate={new Date('2030-12-31')}
                />
              </LocalizationProvider>
            </div>
          )}
          {filter?.flag === 'month' && (
            <div className={'d-flex gap-3'}>
              <FormControl fullWidth>
                <InputLabel id='demo-simple-select-label'>기간 선택</InputLabel>
                <Select
                  labelId='demo-simple-select-label'
                  id='select-week'
                  defaultValue={3}
                  label='기간 선택 '
                  onChange={(e) => {
                    setFilter({...filter, start: e.target.value})
                  }}
                >
                  {_.map(_.range(1, 12), (el, i) => (
                    <MenuItem value={i + 1} key={i}>
                      {el}개월 전
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={['year', 'month']}
                  openTo='month'
                  mask={'____.__'}
                  disableFuture={true}
                  inputFormat={'YYYY년 MM월'}
                  value={date}
                  onChange={(newValue: any) => {
                    setDate(newValue)
                    setFilter({
                      ...filter,
                      end: dayjs(newValue).format('YYYYMM'),
                    })
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  minDate={new Date('2023-01-01')}
                  maxDate={new Date('2030-12-31')}
                />
              </LocalizationProvider>
            </div>
          )}
        </div>
      </Fragment>
    ),
    useSwitch: (
      <div
        className={'align-self-center text-center '}
        style={{width: '400px'}}
        key={'fC-useSwitch'}
      >
        <FormControl component='fieldset' variant='standard'>
          <FormLabel
            component='legend'
            className={'m-0 fw-bold text-dark'}
            style={{fontSize: '18px'}}
          >
            <u>사용량 존재여부</u>
          </FormLabel>
          <FormGroup>
            <Stack direction='row' spacing={1} alignItems='center'>
              <Typography>전체</Typography>
              <CustomSwitch
                inputProps={{'aria-label': 'ant design'}}
                onChange={(e) => setFilter({...filter, flag: e.target.checked})}
                defaultValue={filter?.flag}
              />
              <Typography>사용량 존재</Typography>
            </Stack>
          </FormGroup>
        </FormControl>
      </div>
    ),
    timeRange: (
      <div id={'time-range'} className={'col-lg-2 d-flex gap-3'} key={'fC-timeRange'}>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>시작시간</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={filter?.start}
            label='시작시간'
            onChange={async (e) => {
              if (e.target.value > filter?.end) {
                await validationAlert('시작시간은 마지막시간보다 작아야 합니다.', 'warning')
                return
              }
              setFilter({...filter, start: e.target.value})
            }}
            defaultValue={0}
          >
            {_.map(_.range(0, 24), (el, i) => {
              return (
                <MenuItem value={el} key={i}>
                  {el < 10 ? `0${el}` : el}시
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        <span className={'mx-1 align-self-center'}>~</span>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>마지막시간</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={filter?.end}
            label='마지막시간'
            onChange={(e: any) => setFilter({...filter, end: e.target.value})}
            defaultValue={6}
          >
            {_.map(_.range(filter?.start, 24), (el, i) => {
              return (
                <MenuItem value={el} key={i}>
                  {el < 10 ? `0${el}` : el}시
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    ),
    checkStatus: (
      <FormControl
        className={'col-xxl-2 col-xl-2 col-lg-2 col-md-4 col-sm-5'}
        size={isMobile ? 'small' : undefined}
        key={'fC-checkStatus'}
      >
        <InputLabel id='demo-simple-select-label'>검수상태</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='checkStatus'
          label='검수상태'
          defaultValue={filter.checkStatus}
          onChange={(e) => {
            setFilter({...filter, checkStatus: e.target.value})
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'none'}>NONE</MenuItem>
          <MenuItem value={'pass'}>PASS</MenuItem>
          <MenuItem value={'fail'}>FAIL</MenuItem>
        </Select>
      </FormControl>
    ),
    betweenRange: (
      <Tooltip
        title={<span className={'fs-6 fw-bolder '}>시작날짜와 종료날짜를 모두 선택해주세요.</span>}
        leaveDelay={1000}
        arrow={true}
        placement={'top'}
        TransitionComponent={Fade}
        TransitionProps={{timeout: 600}}
        key={'betweenRange'}
      >
        <div id={'date-range'} className={'col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-5'}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            localeText={{start: '검색시작', end: '검색종료'}}
          >
            <DateRangePicker
              className={'justify-content-center '}
              value={date}
              mask='____/__/__'
              inputFormat={'YYYY/MM/DD'}
              onChange={(newValue: any) => {
                setDate(newValue)
                setFilter({
                  ...filter,
                  startDate: newValue[0]?.format('YYYY-MM-DD'),
                  endDate: newValue[1]?.format('YYYY-MM-DD'),
                })
              }}
              renderInput={(startProps, endProps) => {
                return (
                  <React.Fragment>
                    <TextField {...startProps} autoComplete={'off'} size={isMobile ? 'small' : undefined} />
                    <Box sx={{mx: 1}}> ~ </Box>
                    <TextField {...endProps} autoComplete={'off'} size={isMobile ? 'small' : undefined} />
                  </React.Fragment>
                )
              }}
            />
          </LocalizationProvider>
        </div>
      </Tooltip>
    ),
    deviceDateRange: (
      <Fragment key={'fC-deviceDateRange'}>
        <div id={'date-range'} className={'col-lg-2'}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            localeText={{start: '검색 시작기준', end: '검색 종료기준'}}
          >
            <DateRangePicker
              className={'justify-content-center '}
              value={date}
              onChange={(newValue: any) => {
                setDate(newValue)
                setFilter({
                  ...filter,
                  startDate: newValue[0]?.format('YYYYMMDD'),
                  endDate: newValue[1]?.format('YYYYMMDD'),
                })
              }}
              disableFuture
              renderInput={(startProps, endProps) => (
                <React.Fragment>
                  <TextField {...startProps} />
                  <Box sx={{mx: 1}}> ~ </Box>
                  <TextField {...endProps} />
                </React.Fragment>
              )}
            />
          </LocalizationProvider>
        </div>
        <Button
          variant={'outlined'}
          size={'large'}
          onClick={() => {
            if (window.location.href?.includes('task')) {
              setDate([dayjs().subtract(1, 'month'), dayjs()])
              setFilter({
                ...filter,
                startDate: dayjs().subtract(1, 'month').format('YYYYMMDD'),
                endDate: dayjs().format('YYYYMMDD'),
              })
            } else {
              setDate([dayjs(), dayjs()])
              setFilter({
                ...filter,
                startDate: dayjs().format('YYYYMMDD'),
                endDate: dayjs().format('YYYYMMDD'),
              })
            }
          }}
        >
          <RefreshIcon sx={{width: 24, height: 24}} />
        </Button>
      </Fragment>
    ),
    reason: (
      <FormControl className={'col-lg-1'} key={'fC-reason'}>
        <InputLabel id='demo-simple-select-label'>원인명</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          label='원인명'
          defaultValue={filter.cause}
          onChange={(e) => {
            setFilter({
              ...filter,
              cause: e.target.value,
            })
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          {_.map(causeList, (el, i) => {
            return (
              <MenuItem value={el.codeIdx} key={i}>
                {el.codeName}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    ),
    solution: (
      <FormControl className={'col-lg-1'} key={'fC-solution'}>
        <InputLabel id='demo-simple-select-label'>해결명</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          label='배터리 상태'
          defaultValue={filter.solution}
          onChange={(e) => {
            setFilter({
              ...filter,
              solution: e.target.value,
            })
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          {_.map(solutionList, (el, i) => {
            return (
              <MenuItem value={el.codeIdx} key={i}>
                {el.codeName}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    ),
    result: (
      <FormControl className={'col-lg-1'} key={'fC-result'}>
        <InputLabel id='demo-simple-select-label'>결과</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          label='결과'
          defaultValue={filter?.result}
          onChange={(e) => {
            setFilter({
              ...filter,
              result: e.target.value,
            })
          }}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'true'}>해결</MenuItem>
          <MenuItem value={'false'}>미해결</MenuItem>
        </Select>
      </FormControl>
    ),
    role: (
      <FormControl className={'col-lg-1'} key={'fC-role'}>
        <InputLabel id='demo-simple-select-label'>권한 검색</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          label='권한 검색'
          value={filter.accountType}
          onChange={(e) => setFilter({...filter, accountType: e.target.value})}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          {accountTypeList?.map((el: any, i: number) => {
            return (
              <MenuItem key={i} value={el.accountType}>
                {el.accountTypeName}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    ),
    isActive: (
      <FormControl className={'col-lg-1'} key={'fC-isActive'}>
        <InputLabel id='demo-simple-select-label'>활성화 상태</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='customer-target'
          label='활성화 상태'
          value={filter.idActiveStatus}
          onChange={(e) => setFilter({...filter, idActiveStatus: e.target.value})}
        >
          <MenuItem value={'all'}>전체</MenuItem>
          <MenuItem value={'true'}>활성화</MenuItem>
          <MenuItem value={'false'}>비활성화</MenuItem>
        </Select>
      </FormControl>
    ),

    uiseongDistrict: (
      <FormControl className={'col-lg-2'} key={'fC-isActive'}>
        <InputLabel id='demo-simple-select-label'>분구 (다중 선택 가능)</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='uiseong-district'
          label='분구 (다중 선택 가능)'
          multiple
          value={filter.district ? filter.district.split(',') : ['전체']}
          onChange={(e) => {
            const selectedValues = e.target.value.filter((v: any) => v !== '전체') // '전체' 제거
            setFilter({
              ...filter,
              district: selectedValues.length > 0 ? selectedValues.join(',') : '',
            })
          }}
        >
          <MenuItem disabled value='전체'>
            전체
          </MenuItem>
          {Object.values(dividedDistrictUiseongEnum).map((district) => (
            <MenuItem key={district} value={district}>
              {district}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ),

    serverCycle: (
      <FormControl sx={{minWidth: 200}} key='fC-serverCycle'>
        <InputLabel id='demo-simple-select-label'>통신주기(다중선택)</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='uiseong-serverCycle'
          label='통신주기(다중선택)'
          multiple
          value={filter.serverCycle ? filter.serverCycle.split(',') : ['all']}
          onChange={(e) => {
            const selectedValues = e.target.value.filter((v: any) => v !== 'all') // '전체' 제거
            setFilter({
              ...filter,
              serverCycle: selectedValues.length > 0 ? selectedValues.join(',') : '',
            })
          }}
        >
          <MenuItem disabled value='all'>
            전체
          </MenuItem>
          {Object.entries(serverCycleOptions).map(([cycle, label]) => (
            <MenuItem key={cycle} value={cycle}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ),
  }

  const formActions: any = {
    allocationExcelNDelete: (
      <div className='flex gap-3' key={'fA-allocationExcel'}>
        <Button
          variant={'contained'}
          color={'success'}
          sx={{height: 40}}
          startIcon={<DownloadIcon />}
          onClick={() => onDownloadOpen?.()}
        >
          다운로드
        </Button>

        <Button
          variant={'contained'}
          color={'error'}
          sx={{height: 40}}
          startIcon={<DeleteForeverIcon />}
          onClick={async () => {
            await onDelete()
          }}
        >
          삭제
        </Button>
      </div>
    ),

    delete: (
      <Button
        key={'fA-delete'}
        variant={'contained'}
        color={'error'}
        sx={{height: 40}}
        startIcon={<DeleteForeverIcon />}
        onClick={async () => {
          await onDelete()
        }}
      >
        삭제
      </Button>
    ),

    assign: (
      <div className='flex gap-3' key={'fA-assign'}>
        <Button
          variant={'contained'}
          data-bs-toggle='modal'
          onClick={async () => {
            const myModal: any = new bootstrap.Modal(
              document.getElementById('customerAllocationModal') as HTMLElement
            )
            if (checkData?.length === 0) {
              await noDataAlert()
              return
            } else {
              myModal.show()
              setTypeName('assigned')
            }
          }}
        >
          할당
        </Button>
        <Button
          variant={'contained'}
          color={'error'}
          onClick={async () => {
            await onCancel()
          }}
        >
          할당 취소
        </Button>
      </div>
    ),

    deviceCheck: (
      <div id={'table-header-center'} className='flex flex-wrap gap-3' key={'fA-deviceCheck'}>
        <Button
          variant={'contained'}
          color={'success'}
          startIcon={<TaskAltIcon />}
          onClick={() => onFotaOpen?.()}
        >
          일괄 서버 변경
        </Button>

        <Button
          variant={'contained'}
          startIcon={<TaskAltIcon />}
          onClick={async () => {
            if (checkData === 0) {
              await noDataAlert()
              return
            }
            if (checkData.length >= 5000) {
              await normalAlert('5000개 이상의 단말기는 한번에 승인할 수 없습니다.')
              return
            }
            buttonHandler('pass')
          }}
        >
          PASS
        </Button>
        <Button
          variant={'contained'}
          color={'error'}
          startIcon={<HighlightOffIcon />}
          onClick={async () => {
            if (checkData === 0) {
              await noDataAlert()
              return
            }
            if (checkData.length >= 5000) {
              await normalAlert('5000개 이상의 단말기는 한번에 미승인 할 수 없습니다.')
              return
            }
            buttonHandler('fail')
          }}
        >
          FAIL
        </Button>
      </div>
    ),
    deviceAssign: (
      <div id={'table-header-end'} className='flex flex-wrap gap-3' key={'fA-deviceAssign'}>
        <Button
          className={'mx-1'}
          variant={'contained'}
          color={'primary'}
          startIcon={<OfflinePinIcon />}
          data-bs-toggle={'offcanvas'}
          data-bs-target='#allocationBatchRegister'
          aria-controls='allocationBatchRegister'
        >
          일괄등록
        </Button>
        <Button
          variant={'contained'}
          startIcon={<TaskAltIcon />}
          onClick={async () => {
            const myModal: any = new bootstrap.Modal(
              document.getElementById('deviceAllocationModal') as HTMLElement
            )
            if (checkData.length >= 5000) {
              await normalAlert('5000개 이상은 할당할 수 없습니다.')
              return
            }
            if (checkData.length === 0) {
              await noDataAlert()
              return
            } else {
              myModal.show()
              setTypeName('assigned')
            }
          }}
        >
          할당
        </Button>
        <Button
          variant={'contained'}
          color={'error'}
          startIcon={<HighlightOffIcon />}
          onClick={async () => {
            if (checkData.length >= 5000) {
              await normalAlert('5000개 이상은 한번에 할당 취소를 할 수 없습니다.')
              return
            }
            if (checkData.length === 0) {
              await noDataAlert()
              return
            } else {
              await onCancel()
            }
          }}
        >
          할당 취소
        </Button>
      </div>
    ),
    deviceDelete: (
      <Button
        key={'fA-deviceDelete'}
        variant={'contained'}
        color={'error'}
        startIcon={<DeleteIcon />}
        onClick={async () => {
          if (checkData === 0) {
            await noDataAlert()
            return
          }
          if (checkData.length >= 5000) {
            await normalAlert('5000개 이상의 단말기는 한번에 삭제할 수 없습니다.')
            return
          }
          buttonHandler('delete')
        }}
      >
        삭제
      </Button>
    ),

    download: (
      <Button
        key={'fA-download'}
        variant={'contained'}
        color={'success'}
        sx={{height: 40}}
        startIcon={<DownloadIcon />}
        onClick={() => onDownloadOpen?.()}
      >
        다운로드
      </Button>
    ),

    photoDownload: (
      <div key={'fA-photoDownload'}>
        <Button
          variant='contained'
          color='success'
          sx={{height: 40}}
          startIcon={<DownloadIcon />}
          onClick={handleClick}
        >
          사진첩 다운로드
        </Button>
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={() => downloadApi('pdf')}>PDF 다운로드</MenuItem>
          <MenuItem onClick={() => downloadApi('excel')}>엑셀 다운로드</MenuItem>
        </Menu>
      </div>
    ),

    correct: (
      <Button
        key={'correct'}
        variant={'contained'}
        color={'success'}
        sx={{height: 40}}
        onClick={() => {
          setOpenCorrectModal(true)
        }}
      >
        수용가 보정
      </Button>
    ),

    as: (
      <div className='flex flex-wrap gap-2 items-center' id={'table-header-end'} key={'fA-as'}>
        <FormControl sx={{minWidth: 160, maxWidth: 220, height: 40}} size={'small'}>
          <Select
            id='reason-select'
            displayEmpty
            value={asReasonData}
            onChange={(e) => setAsReasonData(e.target.value)}
            sx={{height: 40}}
            renderValue={(selected) =>
              selected ? causeList?.find((el: any) => el.codeIdx === selected)?.codeName : '원인을 골라주세요.'
            }
          >
            {_.map(causeList, (el, i) => {
              return (
                <MenuItem value={el?.codeIdx} key={i}>
                  {el?.codeName}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        <Button
          variant={'outlined'}
          color={'error'}
          sx={{height: 40}}
          disabled={asPending}
          onClick={async () => {
            if (asPending) return
            setAsPending(true)
            try {
              await registerAs(userInfo, checkData, {
                cause: asReasonData,
                causeName: causeList?.find((el: any) => el.codeIdx === asReasonData)?.codeName,
                onDone: () => {
                  setCheckData([])
                  setSelectionModel([])
                  setAsReasonData('')
                  asRefreshCallback()
                },
              })
            } finally {
              setAsPending(false)
            }
          }}
        >
          A/S
        </Button>
        <Button
          variant={'outlined'}
          color={'error'}
          sx={{height: 40}}
          disabled={asPending}
          onClick={async () => {
            if (asPending) return
            setAsPending(true)
            try {
              await cancelAs(userInfo, checkData, {
                onDone: () => {
                  setCheckData([])
                  setSelectionModel([])
                  asRefreshCallback()
                },
              })
            } finally {
              setAsPending(false)
            }
          }}
        >
          A/S 취소
        </Button>
      </div>
    ),
    asCancel: (
      <Button
        key={'fA-asCancle'}
        variant={'outlined'}
        className={'mx-1'}
        color={'error'}
        startIcon={<BuildIcon />}
        onClick={() => {
          onCancel()
        }}
      >
        A/S 취소
      </Button>
    ),
    asAssign: (
      <div id={'asAssign'} key={'fA-asAssign'}>
        <Button
          className={'mx-1'}
          variant={'contained'}
          color={'primary'}
          startIcon={<OfflinePinIcon />}
          data-bs-toggle={'offcanvas'}
          data-bs-target='#asBatchRegister'
          aria-controls='asBatchRegister'
        >
          일괄등록
        </Button>
        <Button
          variant={'contained'}
          className={'mx-1'}
          color={'primary'}
          startIcon={<OfflinePinIcon />}
          data-bs-toggle='modal'
          onClick={async () => {
            const myModal: any = new bootstrap.Modal(
              document.getElementById('asAllocationModal') as HTMLElement
            )
            if (checkData.length === 0) {
              await noDataAlert()
              return
            } else {
              if (
                _.some(checkData, (el) => el.resultIdx !== null && typeof el.resultIdx === 'string')
              ) {
                await normalAlert('AS 취소할 수 없는 AS가 포함되어 있습니다.')
                return
              }
              myModal.show()
            }
          }}
        >
          할당
        </Button>
        <Button
          variant={'contained'}
          className={'mx-1'}
          color={'error'}
          startIcon={<UnpublishedIcon />}
          onClick={() => {
            onAssignCancel()
          }}
        >
          할당취소
        </Button>
      </div>
    ),
    recycle: (
      <Button
        key={'fA-recycle'}
        variant={'contained'}
        className={'mx-1 fw-bold fs-4'}
        color={'secondary'}
        startIcon={<ReplayIcon />}
        onClick={() => buttonHandler()}
      >
        재사용
      </Button>
    ),
    create: (
      <div className='flex gap-3' key={'fA-create'}>
        <button
          id={'registerCollapseBtn'}
          className={'btn btn-primary align-self-center fw-bold'}
          onClick={() => onCreateUserModalOpen()}
        >
          계정등록
        </button>
        <button
          type='button'
          className='btn btn-info align-self-center fw-bold'
          data-bs-toggle='modal'
          data-bs-target='#addAccountType'
        >
          계정타입 설정
        </button>
      </div>
    ),

    leak: (
      <Fragment key={'fA-leak'}>
        <div className={'d-flex align-items-center gap-4'}>
          <div className={'d-flex flex-column align-items-center'}>
            {!props.loading ? (
              <>
                <span className={'fs-3'}>
                  전체 : <strong>{total}</strong>건 중 누수 의심 <strong>{errorCount}</strong> 건
                </span>
                {/* <span className={'fs-3'}>
                  전체 : <strong>{total}</strong> 건
                </span> */}
              </>
            ) : (
              <span className={'fs-3'}>
                <strong>검색중..</strong>
              </span>
            )}
          </div>
          {!props.loading && (
            <Button
              type='button'
              variant={'contained'}
              className={`align-self-center fw-bold`}
              onClick={() => {
                !props.loading && asValue?.setLeakModalOpen(true)
              }}
            >
              {!props.loading ? '확인이 필요한 수용가' : '검색중..'}
            </Button>
          )}
        </div>
        {!props.loading && (
          <div className={'d-flex gap-4 align-items-center'}>
            <div>
              <FormControl component='fieldset' variant='standard'>
                <FormLabel
                  component='legend'
                  className={'m-0 fw-bold text-dark'}
                  style={{fontSize: '18px', textAlign: 'center'}}
                >
                  <u>이미지 열 추가</u>
                </FormLabel>
                <FormGroup
                  style={{
                    alignItems: 'center',
                  }}
                >
                  <Stack direction='row' spacing={1} alignItems={'center'}>
                    <Typography>X</Typography>
                    <CustomSwitch
                      inputProps={{'aria-label': 'ant design'}}
                      onChange={(e) => setFilter({...filter, flag: e.target.checked})}
                      defaultValue={filter?.flag}
                    />
                    <Typography>O</Typography>
                  </Stack>
                </FormGroup>
              </FormControl>
            </div>

            <Button
              variant={'outlined'}
              color={'success'}
              startIcon={<ListAltIcon sx={{width: 24, height: 24}} />}
              onClick={() => {
                asValue?.excelDownLoad(filter)
              }}
            >
              Download
            </Button>
          </div>
        )}

        {asValue?.officeName !== '전체' && asValue?.officeName !== '영아이티' ? (
          <div className={'d-flex gap-3'}>
            <span className={'fs-4 text-primary fw-bolder'}>
              <span>{asValue?.officeName}</span>의 누수 의심 설정값은
              <span className={'text-black'}> {asValue?.leakUseCycle} </span>
              <span className={'text-black'}>
                {' '}
                {asValue?.leakUseStandard}
                {asValue?.leakUseUnit}{' '}
              </span>
              입니다.
            </span>
          </div>
        ) : (
          <div className={'d-flex gap-3'}>
            <span className={'fs-4 text-primary fw-bolder'}>사업소를 선택해주세요.</span>
          </div>
        )}
      </Fragment>
    ),
    unused: (
      <Fragment key={'fA-unused'}>
        <div className={'d-flex align-items-center gap-4'}>
          <div className={'d-flex flex-column align-items-center'}>
            <span className={'fs-3'}>
              전체 : <strong>{total}</strong> 건
            </span>
          </div>
        </div>

        {asValue?.officeName !== '전체' && asValue?.officeName !== '영아이티' ? (
          <div className={'d-flex gap-3'}>
            <span className={'fs-4 text-primary fw-bolder'}>
              <span>{asValue?.officeName}</span>의 장기미사용 설정값은
              <span className={'text-black'}> {asValue?.longtermStandard}일</span>
              입니다.
            </span>
          </div>
        ) : (
          <div className={'d-flex gap-3'}>
            <span className={'fs-4 text-primary fw-bolder'}>사업소를 선택해주세요.</span>
          </div>
        )}
      </Fragment>
    ),

    asAssignAll: (
      <Button
        key={'fA-asAssignAll'}
        variant={'contained'}
        color={'primary'}
        data-bs-toggle={'offcanvas'}
        data-bs-target='#asBatchRegister'
        aria-controls='asBatchRegister'
      >
        일괄등록
      </Button>
    ),
    blank: (
      <Fragment key={'fA-blank'}>
        <div
          onClick={() => setHiddenClick(!hiddenClick)}
          className={'d-flex align-items-center gap-4'}
          style={{width: '300px', height: '36px'}}
        >
          &nbsp;
        </div>
      </Fragment>
    ),
  }

  const searchOptionsControl: any = {
    customerNumber: (
      <FormControlLabel
        key={'sO-customerNumber'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  customerNumber: e.target.checked,
                },
              })
            }}
          />
        }
        label='수용가번호'
      />
    ),
    customerName: (
      <FormControlLabel
        key={'sO-customerName'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  customerName: e.target.checked,
                },
              })
            }}
          />
        }
        label='이름'
      />
    ),
    address: (
      <FormControlLabel
        key={'sO-address'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  address: e.target.checked,
                },
              })
            }}
          />
        }
        label='주소'
      />
    ),
    installerId: (
      <FormControlLabel
        key={'sO-installerId'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  installId: e.target.checked,
                },
              })
            }}
          />
        }
        label='설치자 ID'
      />
    ),
    installerName: (
      <FormControlLabel
        key={'sO-installerName'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  installerName: e.target.checked,
                },
              })
            }}
          />
        }
        label='설치자 이름'
      />
    ),
    managerName: (
      <FormControlLabel
        key={'sO-managerName'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  managerName: e.target.checked,
                },
              })
            }}
          />
        }
        label='담당자'
      />
    ),
    serialNumber: (
      <FormControlLabel
        key={'sO-serialNumber'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  serialNumber: e.target.checked,
                },
              })
            }}
          />
        }
        label='단말기 SN'
      />
    ),
    imei: (
      <FormControlLabel
        key={'sO-imei'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  imei: e.target.checked,
                },
              })
            }}
          />
        }
        label='IMEI'
      />
    ),
    memo: (
      <FormControlLabel
        key={'sO-memo'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  memo: e.target.checked,
                },
              })
            }}
          />
        }
        label='메모'
      />
    ),
    meterDiameter: (
      <FormControlLabel
        key={'sO-meterDiameter'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  meterDiameter: e.target.checked,
                },
              })
            }}
          />
        }
        label='구경'
      />
    ),
    deviceVersion: (
      <FormControlLabel
        key={'sO-deviceVerision'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({...filter, deviceVersion: e.target.checked})
            }}
          />
        }
        label='단말기 펌웨어'
      />
    ),
    complete: (
      <FormControlLabel
        key={'sO-complete'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                imageSearchOption: {
                  ...filter.imageSearchOption,
                  complete: e.target.checked,
                },
              })
            }}
          />
        }
        label='정상처리'
      />
    ),
    fail: (
      <FormControlLabel
        key={'sO-fail'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                imageSearchOption: {
                  ...filter.imageSearchOption,
                  fail: e.target.checked,
                },
              })
            }}
          />
        }
        label='인식실패'
      />
    ),
    digit: (
      <FormControlLabel
        key={'sO-digit'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                imageSearchOption: {
                  ...filter.imageSearchOption,
                  digit: e.target.checked,
                },
              })
            }}
          />
        }
        label='자리수 인식 오류'
      />
    ),
    wait: (
      <FormControlLabel
        key={'sO-wait'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                imageSearchOption: {
                  ...filter.imageSearchOption,
                  wait: e.target.checked,
                },
              })
            }}
          />
        }
        label='인식 대기중'
      />
    ),
    imgerr: (
      <FormControlLabel
        key={'sO-imgerr'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                imageSearchOption: {
                  ...filter.imageSearchOption,
                  imgerr: e.target.checked,
                },
              })
            }}
          />
        }
        label='비정상 이미지'
      />
    ),
    fix: (
      <FormControlLabel
        key={'sO-fix'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                imageSearchOption: {
                  ...filter.imageSearchOption,
                  fix: e.target.checked,
                },
              })
            }}
          />
        }
        label='검침값이 수정된 이미지'
      />
    ),
    asSerialNumber: (
      <FormControlLabel
        key={'sO-asSerialNumber'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  asSerialNumber: e.target.checked,
                },
              })
            }}
          />
        }
        label='AS 단말기S/N'
      />
    ),
    asName: (
      <FormControlLabel
        key={'sO-asName'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  asName: e.target.checked,
                },
              })
            }}
          />
        }
        label='A/S기사 이름'
      />
    ),
    asId: (
      <FormControlLabel
        key={'sO-asId'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  asId: e.target.checked,
                },
              })
            }}
          />
        }
        label='A/S기사 ID'
      />
    ),
    firmware: (
      <FormControlLabel
        key={'sO-firmware'}
        control={
          <Checkbox
            onChange={(e) => {
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  deviceVersion: e.target.checked,
                },
              })
            }}
          />
        }
        label='펌웨어'
      />
    ),
    userId: (
      <FormControlLabel
        key={'sO-userId'}
        control={
          <Checkbox
            onChange={(e) =>
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  id: !filter.searchOption.id,
                },
              })
            }
          />
        }
        label='ID로 검색'
      />
    ),
    userName: (
      <FormControlLabel
        key={'sO-userName'}
        control={
          <Checkbox
            onChange={(e) =>
              setFilter({
                ...filter,
                searchOption: {
                  ...filter.searchOption,
                  name: !filter.searchOption.name,
                },
              })
            }
          />
        }
        label='이름으로 검색'
      />
    ),
  }

  const searchFieldHandler = (newSearchField: boolean) => {
    const searchFilter = newSearchOptions?.filter((opt: any) => opt.field === 'filter')

    const textFields = newSearchOptions?.filter((opt: any) => opt.field === 'text')
    const defaultselectFields = newSearchOptions?.filter(
      (opt: any) => opt.field === 'defaultSelect'
    )
    const selectFields = newSearchOptions?.filter((opt: any) => opt.field === 'select')
    const dateFields = newSearchOptions?.filter((opt: any) => opt.field === 'date')

    // 이슈 조회 시작일/종료일: 자유롭게 선택하고, 1개월 초과 검증은 검색 시점에 처리
    // 검증 실패 시 issueDateError로 빨간 테두리(에러 상태) 표시
    const issueDateRangeProps = (id: string) => {
      if (id === 'startIssueDate' || id === 'endIssueDate') {
        return {format: 'YYYYMMDD', error: !!issueDateError}
      }
      return {}
    }

    switch (newSearchField) {
      case true:
        return (
          <>
            <div
              className={`relative flex flex-col ${
                compactSearch ? 'p-2' : 'p-4'
              } rounded-lg bg-gray-50 transition-all duration-800 ${
                expanded
                  ? 'h-auto'
                  : `${
                      compactSearch ? 'h-[160px]' : 'h-[180px]'
                    } overflow-hidden cursor-pointer ease-in-out`
              }`}
              onClick={() => setExpanded(true)}
            >
              <div
                className={`flex flex-wrap ${compactSearch ? 'gap-2 pb-2' : 'gap-4 pb-4'} w-full`}
              >
                <div
                  className={`w-full xl:w-auto flex flex-col rounded-md ${
                    compactSearch ? 'p-1' : 'p-2'
                  }`}
                >
                  <h3
                    className={`font-semibold text-gray-800 ${
                      compactSearch ? 'text-base mb-1' : 'text-lg mb-2'
                    }`}
                  >
                    검색
                  </h3>
                  <div className={`flex flex-wrap ${compactSearch ? 'gap-1.5' : 'gap-2'}`}>
                    {searchFilter.map(({id, label, multiple, options}: any) => (
                      <CustomSelectBox
                        key={id}
                        id={id}
                        label={label}
                        filter={filter}
                        setFilter={setFilter}
                        multiple={multiple ?? false}
                        compact={compactSearch}
                      />
                    ))}
                    {/* <CustomSelectBox
                      key={'searchDataField'}
                      id={'searchDataField'}
                      label={'필터'}
                      filter={filter}
                      setFilter={setFilter}
                      multiple={true}
                    /> */}
                    {textFields.map(({id, label}: any) => (
                      <CustomTextField
                        key={id}
                        id={id}
                        label={label}
                        filter={filter}
                        setFilter={setFilter}
                        onEnter={searchCallback}
                        compact={compactSearch}
                      />
                    ))}
                  </div>
                </div>
                <div
                  className={`w-full lg:w-auto flex flex-col rounded-md ${
                    compactSearch ? 'p-1' : 'p-2'
                  }`}
                >
                  <h3
                    className={`font-semibold text-gray-800 ${
                      compactSearch ? 'text-base mb-1' : 'text-lg mb-2'
                    }`}
                  >
                    기본 검색
                  </h3>
                  <div className={`flex flex-wrap ${compactSearch ? 'gap-1.5' : 'gap-2'}`}>
                    {defaultselectFields.map(({id, label, multiple, options}: any) => (
                      <CustomSelectBox
                        key={id}
                        id={id}
                        label={label}
                        filter={filter}
                        setFilter={setFilter}
                        multiple={multiple ?? false}
                        options={options ?? null}
                        compact={compactSearch}
                      />
                    ))}
                    {dateFieldsInDefaultSearch &&
                      dateFields.map(({id, label}: any) => (
                        <CustomDateBox
                          key={id}
                          id={id}
                          label={label}
                          filter={filter}
                          setFilter={setFilter}
                          compact={compactSearch}
                          flashKey={id === 'startIssueDate' ? issueStartDateFlashKey : undefined}
                          {...issueDateRangeProps(id)}
                        />
                      ))}
                    {dateFieldsInDefaultSearch &&
                      Array.isArray(issueDateQuickButtons) &&
                      issueDateQuickButtons.length > 0 && (
                        // 날짜 입력창과 하단 라인을 맞추기 위해 items-end로 정렬
                        <div className='flex items-end gap-1.5'>
                          {issueDateQuickButtons.map((btn: any) => {
                            const buttonEl = (
                              <button
                                type='button'
                                onClick={btn.onClick}
                                style={{height: compactSearch ? '2.75rem' : '3.5rem'}}
                                className='px-4 rounded-md border border-gray-300 bg-white text-gray-700 text-base font-medium shadow-sm transition hover:bg-gray-100 hover:border-gray-400 whitespace-nowrap'
                              >
                                {btn.label}
                              </button>
                            )
                            return btn.tooltip ? (
                              <CustomWidthTooltip key={btn.label} title={btn.tooltip} arrow>
                                {buttonEl}
                              </CustomWidthTooltip>
                            ) : (
                              <span key={btn.label}>{buttonEl}</span>
                            )
                          })}
                        </div>
                      )}
                  </div>
                </div>
                <div
                  className={`flex flex-col rounded-md items-start ${
                    compactSearch ? 'p-1' : 'p-2'
                  }`}
                >
                  <h3
                    className={`font-semibold text-gray-800 ${
                      compactSearch ? 'text-base mb-1' : 'text-lg mb-2'
                    }`}
                  >
                    상태
                  </h3>
                  <div className={`flex flex-wrap ${compactSearch ? 'gap-1.5' : 'gap-2'}`}>
                    {selectFields.map(({id, label, multiple, options}: any) => (
                      <CustomSelectBox
                        key={id}
                        id={id}
                        label={label}
                        filter={filter}
                        setFilter={setFilter}
                        multiple={multiple ?? false}
                        options={options ?? null}
                        externalFilter={newSearchFieldFilter}
                        compact={compactSearch}
                      />
                    ))}

                    {!dateFieldsInDefaultSearch && (
                      <div className={`flex flex-wrap ${compactSearch ? 'gap-1.5' : 'gap-2'}`}>
                        {dateFields.map(({id, label}: any) => (
                          <CustomDateBox
                            key={id}
                            id={id}
                            label={label}
                            filter={filter}
                            setFilter={setFilter}
                            compact={compactSearch}
                            {...issueDateRangeProps(id)}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className='w-full flex justify-center gap-2'>
                <Button
                  variant='contained'
                  color='primary'
                  className='w-full md:w-1/5'
                  sx={{
                    fontSize: '0.875rem',
                    height: compactSearch ? '32px' : '40px',
                    padding: '4px 8px',
                  }}
                  onClick={async () => {
                    if (!loading) {
                      await searchCallback()
                    }
                  }}
                >
                  {loading ? '검색 중 입니다.' : '검색'}
                </Button>
                <Button
                  variant='contained'
                  color='secondary'
                  className='w-[50px]'
                  sx={{
                    fontSize: '0.875rem',
                    height: compactSearch ? '32px' : '40px',
                    padding: '4px 8px',
                  }}
                  onClick={async () => {
                    await resetCallbalck()
                  }}
                >
                  <RestartAltIcon />
                </Button>
              </div>
            </div>
            <div
              className={`relative w-full flex justify-center ${
                expanded ? `mt-[40px]` : 'mt-[20px]'
              }`}
            >
              <div
                onClick={(e) => {
                  e.stopPropagation()
                  setExpanded(!expanded)
                }}
                className={`absolute bottom-0 left-0 right-0 cursor-pointer ${
                  expanded ? `h-[40px] ` : 'h-[70px]'
                } bg-gradient-to-t from-gray-200 via-gray-50 to-transparent shadow-md flex justify-center items-center backdrop-blur-[1px] `}
              >
                <Button
                  variant='text'
                  color='primary'
                  className='flex items-center gap-1 px-4 py-2 rounded-full hover:bg-white/80 transition'
                >
                  {expanded ? '접기' : '더 보기'}
                  {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Button>
              </div>
            </div>
          </>
        )
      default: {
        const searchOptionsToggle = !disableSearchOptions && (
          <Tooltip
            TransitionComponent={Fade}
            TransitionProps={{timeout: 600}}
            title={<span className={'fs-8'}>검색항목을 접거나 펼칠 수 있습니다.</span>}
          >
            <Button
              variant={'outlined'}
              size={'large'}
              type='button'
              className={'pulse pulse-primary'}
              onClick={() => {
                setHideSearchOptions(!hideSearchOptions)
              }}
            >
              <MenuIcon sx={{width: 24, height: 24}} />
              <span className={'pulse-ring  border-4'} />
            </Button>
          </Tooltip>
        )

        const searchBar = (
          <div className='flex gap-2 flex-1 min-w-0'>
            <TextField
              variant={'outlined'}
              id={'search-field'}
              placeholder={'검색어를 입력하세요.'}
              autoComplete={'off'}
              value={filter.searchData}
              onChange={(e) => setFilter({...filter, searchData: e.target.value})}
              onKeyDown={async (e) => {
                if (e.key === 'Enter') {
                  await searchCallback()
                }
              }}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='resetBtn'
                      onClick={async () => {
                        await setFilter({...filter, searchData: ''})
                        setTimeout(() => {
                          document.getElementById('search-btn')?.click()
                        }, 100)
                      }}
                      edge='end'
                    >
                      <CancelIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Tooltip
              TransitionComponent={Fade}
              TransitionProps={{timeout: 600}}
              title={
                <span className={'fs-8'}>
                  검색항목을 이용해 정확한 검색 결과를 얻을 수 있습니다.
                </span>
              }
            >
              <Button
                variant={'contained'}
                id={'search-btn'}
                size={'large'}
                type='button'
                onClick={async () => {
                  await searchCallback()
                }}
              >
                <SearchIcon sx={{width: 24, height: 24}} />
              </Button>
            </Tooltip>
          </div>
        )

        const filterControls = control?.map((controlName: any) => formControls[controlName])

        // 모바일: 검색바(1줄) + 필터 드롭다운 풀폭 세로 정렬 / 데스크탑: 기존 한 줄 flex-wrap 유지
        return isMobile ? (
          <div className={'flex flex-col gap-2 p-2'} id={id + '-control-section'}>
            {/* 검색 입력도 필터와 같은 크기 기준을 따른다 */}
            <Box
              className={'flex gap-2 items-stretch'}
              sx={{
                '& .MuiInputBase-root': {height: 48},
                '& .MuiInputBase-input': {fontSize: '1.25rem'},
              }}
            >
              {searchOptionsToggle}
              {searchBar}
            </Box>
            {/* 검색항목: 모바일에선 입력창 바로 아래에 표시 (데스크탑은 좌측 사이드바 유지) */}
            {!disableSearchOptions && hideSearchOptions && (
              <div className={'border border-gray-400 rounded'}>
                <div className={'flex justify-center p-2'}>
                  <h3 className={'font-bold m-0'}>검색항목</h3>
                </div>
                <FormGroup className={'row gap-3 px-3 pb-3'}>
                  {searchOptions?.map(
                    (searchOptionName: any) => searchOptionsControl[searchOptionName]
                  )}
                </FormGroup>
              </div>
            )}
            {control?.length > 0 && (
              <Box
                className={'flex flex-col gap-4 py-2'}
                sx={{
                  // 모바일 필터 드롭다운 가독성 확보 (공용 formControls 미변경, 컨테이너 스코프)
                  '& .MuiInputBase-root': {height: 48},
                  '& .MuiSelect-select': {
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                  },
                  '& .MuiInputLabel-root': {fontSize: '1.125rem'},
                  '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
                    transform: 'translate(14px, 11px) scale(1)',
                  },
                  // 값이 선택되면 라벨이 축소(scale 0.75)되어 작아지므로,
                  // 축소 상태를 직접 지정하고 테두리 노치(legend) 폭도 같은 크기로 맞춘다.
                  '& .MuiInputLabel-shrink': {
                    fontSize: '1rem',
                    fontWeight: 600,
                    transform: 'translate(14px, -8px) scale(1)',
                  },
                  '& .MuiOutlinedInput-notchedOutline legend': {fontSize: '1rem'},
                  '& .MuiSvgIcon-root': {fontSize: '2rem'},
                }}
              >
                {filterControls}
              </Box>
            )}
          </div>
        ) : (
          <div className={'flex flex-wrap gap-2 items-stretch p-2 sm:p-4'} id={id + '-control-section'}>
            {searchOptionsToggle}
            {searchBar}
            {filterControls}
          </div>
        )
      }
    }
  }

  return (
    <div className='card flex-1 p-4' id={id}>
      <h3 className='text-lg font-extrabold mx-4'>
        {headerDescription}
        <CustomWidthTooltip
          title={tooltipText}
          TransitionComponent={Fade}
          TransitionProps={{timeout: 600}}
          placement={'right-start'}
          arrow={true}
          sx={{fontSize: '10px', letterSpacing: '1px', cursor: 'pointer'}}
        >
          <HelpIcon
            color={'primary'}
            sx={{fontSize: '24px'}}
            className={'ms-4 mb-2 cursor-pointer'}
          />
        </CustomWidthTooltip>
      </h3>

      {pannel}

      <div>
        {searchFieldHandler(newSearchField)}

        <div className='flex flex-col lg:flex-row gap-2 mx-2' id='content'>
          {!disableSearchOptions && hideSearchOptions && !isMobile && (
            <div
              id={`filterSection-${id}`}
              className='w-full lg:w-52 shrink-0'
              aria-labelledby={`filterSection-${id}`}
              data-bs-parent={`#filterSection-${id}`}
            >
              <div className='border border-gray-400 rounded mt-3 pl-3 py-3'>
                <div className='flex justify-center p-3' style={{minHeight: 'auto'}}>
                  <h3 className='font-bold m-0'>검색항목</h3>
                </div>
                <FormGroup className={'row gap-3 py-2'}>
                  {searchOptions?.map(
                    (searchOptionName: any) => searchOptionsControl[searchOptionName]
                  )}
                </FormGroup>
              </div>
            </div>
          )}

          <div id={id + '-table-section'} className='flex-1 mt-3 min-w-0'>
            <div
              id={'table-header'}
              className='flex flex-row flex-wrap my-2 justify-between items-center gap-2'
            >
              {actions[0] !== 'leak' && actions[0] !== 'unused' && (
                <div className='flex gap-4'>
                  {!hideTotalCount && (
                    <div>
                      <span className={'fs-3'}>
                        전체 : <strong>{total}</strong> 개
                      </span>
                    </div>
                  )}
                  {selectedCount !== undefined && selectedCount !== 0 ? (
                    <div>
                      <span className='fs-3 text-blue-800'>
                        선택 중 :
                        <span
                          style={{
                            display: 'inline-block',
                            minWidth: '30px',
                            textAlign: 'center',
                          }}
                        >
                          <strong>{selectedCount}</strong>
                        </span>
                        개
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              )}
              {isMobile ? (
                <div className='flex flex-row flex-wrap gap-2 items-center'>
                  {actions?.map((actionName: any) => formActions[actionName])}
                </div>
              ) : (
                actions?.map((actionName: any) => formActions[actionName])
              )}
            </div>

            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MeterariumPageLayout
